import React from "react";
import Theme from "@adsk/alloy-react-theme";
import { getDateStringAsDisplayText } from "@adsk/acc-issues-common/utils/date/dateUtils";
import { Issue } from "@adsk/acc-issues-types";
import { useTranslations } from "@adsk/acc-issues-translations";
import { DisplayUserName, useFormattedUser } from "@adsk/alloy-provider";

export const CreationDetailsSection = ({
  issue,
}: { issue: Issue } & React.HTMLAttributes<HTMLDivElement>) => {
  const { formatDisplayUser } = useFormattedUser();
  const { T } = useTranslations();
  const { userDetails } = formatDisplayUser(issue.createdBy);
  return (
    <div
      data-testid="creation-details-section"
      style={{
        color: Theme.colors.charcoal500,
        paddingTop: "16px",
      }}
    >
      <div>
        {T.translate("issueEditForm.createdBy", {
          name: <DisplayUserName id={issue.createdBy} />,
          createdAt: getDateStringAsDisplayText(issue.createdAt),
        })}
      </div>
      <div>{userDetails?.email}</div>
    </div>
  );
};
